export default __webpack_public_path__ + "fd1a68c46c1ddac9ee4f7ca81cab2349.svg";